import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { ClientConfigService } from './services/client-config.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ClientConfigService) => () =>
        lastValueFrom(configService.loadConfig()),
      deps: [ClientConfigService],
      multi: true,
    },
  ],
};
